import { connect } from 'react-redux'
import { loadAdditionalFormFields, types } from '../../../../actions/projects/form_actions'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.LOAD_PROJECT_GROUPS, types.LOAD_ADDITIONAL_FORM_FIELDS])

export default connect((state: any) => ({
  groups: state.projects?.form?.groups || [],
  locationId: state.projects?.form?.locationId,
  navOrderId: state.projects?.form?.navOrderId,
  jobNumber: state.projects?.form?.jobNumber,
  disabledFields: state.projects?.form?.disabledFields || [],
  fieldsHtml: state.projects?.form?.fieldsHtml,
  isFetching: loadingSelector(state)
}), { loadAdditionalFormFields })
